import axios from 'axios';
import useSWR from 'swr';

const useRoles = (companyUid) => {
  const url = `/admin/role?companyUid=${companyUid}`;
  const swr = useSWR(url, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });

  return swr;
};

export { useRoles };
